import { appointmentRequest } from "./appointmentRequest";

export default appointmentRequest;
